import { FC } from 'react'
import clsx from 'clsx'

import styles from './CMPBanner.module.css'

type CMPBannerProps = {
  primaryBtnText: string
  secondaryBtnText?: string
  className?: string
  bannerStateDescriptor?: string
  description?: string
  title?: string
  primaryBtnLink: string
  seconadaryBtnLink?: string
  onCtaClick?: () => void
  isCtaDisabled: boolean
}

const CMPBanner: FC<CMPBannerProps> = ({
  className,
  bannerStateDescriptor,
  description,
  title,
  primaryBtnText,
  secondaryBtnText,
  primaryBtnLink,
  seconadaryBtnLink,
  onCtaClick,
  isCtaDisabled,
}) => {
  return (
    <div className={className}>
      <div className={styles.wrapper}>
        <div>
          <div className={styles.bannerStateText}>{bannerStateDescriptor}</div>
          <div className={styles.title}>{title}</div>
          <div className={styles.description}>{description}</div>
        </div>
        <div className={styles.buttonWrapper}>
          {onCtaClick ? (
            <button
              className={clsx(styles.primaryButton, styles.button)}
              onClick={onCtaClick}
              disabled={isCtaDisabled}
            >
              {primaryBtnText}
            </button>
          ) : (
            <a
              href={primaryBtnLink}
              target="_blank"
              rel="noreferrer"
              className={clsx(styles.primaryButton, styles.button)}
            >
              {primaryBtnText}
            </a>
          )}
          {seconadaryBtnLink && (
            <a
              href={seconadaryBtnLink}
              target="_blank"
              rel="noreferrer"
              className={clsx(styles.secondaryButton, styles.button)}
            >
              {secondaryBtnText}
            </a>
          )}
        </div>
      </div>
    </div>
  )
}

export default CMPBanner
